import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { ArrowDb } from '../redux/arrowDbSlice';

const useOneArrowDb = (id: string | undefined) : ArrowDb | undefined => {
  const arrowDb = useSelector((state: RootState) => state.arrowDb);
  const arrowValue = id ? arrowDb.arrows[id] : undefined;
  return arrowValue;
}

export default useOneArrowDb;
